import React from 'react'
import FileDropzone from './FileDropzone'
import axiosService from '../../utils/AxiosService'
import { FileEarmarkPlus } from 'react-bootstrap-icons'

export default function DocumentUploader({ url, onDocumentUpload = () => {}, onDocumentUploadFailure = () => {}, campaign_folder_id }) {

  const uploadFile = files => {

    const formData = new FormData()
    if(campaign_folder_id) formData.append('document[campaign_folder_id]', campaign_folder_id)
    formData.append('document[file]', files[0])

    axiosService.post(url, formData, { headers: { "Content-type": "multipart/form-data" } })
    .then(onDocumentUpload)
    .catch(onDocumentUploadFailure)
  }

  return (
    <FileDropzone uploadFiles={uploadFile} icon={<FileEarmarkPlus />} backgroundColor="bg-gray-200" />
  )
}
